import { getbasicdata } from '../../../api';
import * as types from './mutation-types';

export const getInitData = ({ commit }) => {
  getbasicdata().then((data) => {
    if (data.errno === 0 || data.errno === '0') {
      commit(types.UPDATE_INIT_DATA, data);
    }
  });
};



// WEBPACK FOOTER //
// ./src/pages/homepage/store/actions.js